import { ReactNode, createContext } from 'react';
import useLocalStorage from '~/hooks/useLocalStorage';
import { TeamsSearchParams, TeamsSearchParamsContextState } from './types/teams/searchParams';
import { useConstants } from './constants/teams/contants';

const initialState: TeamsSearchParamsContextState = {
  defaultValues: {} as TeamsSearchParams,
  searchParams: {} as TeamsSearchParams,
  setSearchParams: () => {},
};

const TeamsSearchParamsContext = createContext(initialState);

type AgentsSearchParamsProviderProps = {
  children: ReactNode;
};

function TeamsSearchParamsProvider({ children }: AgentsSearchParamsProviderProps) {
  const { defaultValues } = useConstants();

  const [searchParams, setSearchParams] = useLocalStorage<TeamsSearchParams>(
    'searchParams:teams',
    defaultValues
  );

  return (
    <TeamsSearchParamsContext.Provider value={{ searchParams, setSearchParams, defaultValues }}>
      {children}
    </TeamsSearchParamsContext.Provider>
  );
}

export { TeamsSearchParamsProvider, TeamsSearchParamsContext };
